import { useState } from 'react';
import { WhitelistTab } from './SettingsPage';
import { NetworkWhitelistCard } from '@/components/whitelist/NetworkWhitelistCard';
import { ServerWhitelists } from '@/components/whitelist/ServerWhitelists';
import type { WhitelistStatusDTO } from '@/services/api.service';
import { useActiveGroupCapabilities } from '@/stores/gameGroups.store';
import styles from './SettingsPage.module.scss';
import blocks from '@/components/whitelist/Whitelists.module.scss';

/**
 * Listes blanches : celle du réseau (/whitelistall du proxy, par groupe de jeu sur NationsGlory),
 * allumée ou éteinte avec ses noms, puis celle de chaque serveur de jeu (/whitelist).
 *
 * Capacités du satellite du groupe actif (inconnues sur Paladium : tout est montré) : `whitelist`
 * (ModerationAPI) pour la liste du réseau, `whitelistServers` (Pterodactyl, satellite 1.0.24) pour
 * les serveurs. Un groupe commun (lobby) n'a pas de liste du réseau : seuls ses serveurs restent.
 */
export function WhitelistPage() {
  const capabilities = useActiveGroupCapabilities();
  const hasNetwork = !capabilities || capabilities.includes('whitelist');
  const hasServers = !capabilities || capabilities.includes('whitelistServers');
  const [status, setStatus] = useState<WhitelistStatusDTO | null>(null);
  const networkNames = hasNetwork && status?.network !== false;

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <h1 className={styles.title}>Whitelist</h1>
          <p className={styles.subtitle}>Gérez les joueurs autorisés à se connecter, sur le réseau et serveur par serveur</p>
        </div>
      </header>

      <div className={styles.content}>
        {hasNetwork && <NetworkWhitelistCard onStatus={setStatus} />}
        {networkNames && (
          <section className={blocks.section}>
            <div className={blocks.sectionHeader}>
              <div className={blocks.sectionTitle}>Joueurs inscrits sur la liste du réseau</div>
            </div>
            <WhitelistTab serverClearKeepsState={status !== null} />
          </section>
        )}
        {hasServers && <ServerWhitelists />}
      </div>
    </div>
  );
}
